import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import { useStore } from "../../../../connect";

import strings from "../../../../locales/strings";

import styles from "./NotificationErrorPanel.scss";

const cx = classnames.bind(styles);

const NotificationErrorPanel = () => {
  const { notifications } = useStore();

  const handleRetryClick = () => {
    if (!notifications.notificationError.isLoading) {
      notifications.notificationError.retry();
    }
  };

  return notifications.notificationError !== null ? (
    <div className={cx("panel", "error")}>
      <span>{strings.somethingWentWrongWithoutDot}</span>
      <button
        className={cx("glz-link", "glz-is-medium", "update-button")}
        onClick={handleRetryClick}
      >
        <span
          className={cx("refresh-icon", {
            twist: notifications.notificationError.isLoading,
          })}
        >
          <Icon name="ic_refresh" size="s" />
        </span>
        {strings.refresh}
      </button>
    </div>
  ) : null;
};

export default observer(NotificationErrorPanel);
